<mat-card>
    <mat-card-title>
        <span [translate]="'admin.parametres.mobilite.parametres.title'"></span>
    </mat-card-title>
    <mat-card-content>
        <form>
            <fieldset *ngIf="config">
                <div class="row">
                    <!-- Activation de l'application mobile -->
                    <custom-input ngDefaultControl
                                  id="available"
                                  name="available"
                                  [ngModel]="config.available"
                                  [(customModel)]="config.available"
                                  customType="checkbox"
                                  libelle="admin.parametres.mobilite.parametres.activer"></custom-input>
                </div>
            </fieldset>
        </form>
    </mat-card-content>
</mat-card>
<floating-button [listeActions]="listeActions"></floating-button>
